import { useEffect, useRef } from 'react';
/**
 * Barrierearmer Dialog: ESC schließt, Fokus wandert beim Öffnen in den Dialog
 * und beim Schließen zurück, der Hintergrund wird am Scrollen gehindert und der
 * Tastatur-Fokus bleibt im Dialog (Fokusfalle). Der zurückgegebene Ref wird auf
 * das Dialog-Element gelegt.
 */
export function useDialog(onClose) {
    const ref = useRef(null);
    useEffect(() => {
        const vorherFokus = (typeof document !== 'undefined' ? document.activeElement : null);
        const fokussierbare = () => {
            const k = ref.current;
            return k
                ? Array.from(k.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter((el) => el.offsetParent !== null)
                : [];
        };
        // Container fokussierbar machen (Fallback) und Anfangsfokus setzen.
        if (ref.current) {
            ref.current.setAttribute('tabindex', '-1');
        }
        (fokussierbare()[0] ?? ref.current)?.focus?.();
        // Hintergrund-Scroll sperren.
        const body = typeof document !== 'undefined' ? document.body : null;
        const vorherOverflow = body ? body.style.overflow : '';
        if (body) {
            body.style.overflow = 'hidden';
        }
        const onKey = (e) => {
            const k = ref.current;
            if (e.key === 'Escape') {
                e.preventDefault();
                e.stopPropagation();
                onClose();
                return;
            }
            if (e.key === 'Tab' && k) {
                const liste = fokussierbare();
                if (liste.length === 0) {
                    e.preventDefault();
                    k.focus();
                    return;
                }
                const erster = liste[0];
                const letzter = liste[liste.length - 1];
                const aktiv = document.activeElement;
                if (e.shiftKey && aktiv === erster) {
                    e.preventDefault();
                    letzter.focus();
                }
                else if (!e.shiftKey && aktiv === letzter) {
                    e.preventDefault();
                    erster.focus();
                }
                else if (aktiv && !k.contains(aktiv)) {
                    e.preventDefault();
                    erster.focus();
                }
            }
        };
        document.addEventListener('keydown', onKey, true);
        return () => {
            document.removeEventListener('keydown', onKey, true);
            if (body) {
                body.style.overflow = vorherOverflow;
            }
            vorherFokus?.focus?.();
        };
    }, [onClose]);
    return ref;
}
